export default "__VITE_ASSET__bb335001__"